import {FC} from "react";
import IButton from "../../interfaces/Components/IButton";
import {useTranslation} from "react-i18next";
import Spinner from "../Svg/Spinner";
import Arrow from "../Svg/Arrow";

const Button:FC<IButton> = ({onClick, disabled = false, loading = false, text, className = "", arrow = true}) => {
    const {t} = useTranslation();

    return <button onClick={onClick} className={`button ${className} ${disabled ? 'disabled' : ''} ${loading ? 'loading' : ''}`} disabled={disabled || loading}>
        {
            loading ?
                <div className="opacity-80 flex justify-center items-center"><Spinner width="w-8" height="h-8" color="stroke-white" /></div> :
                <span className="flex justify-center items-center gap-2">
                    {text ?? t('common.submit')}
                    {arrow ? <Arrow /> : null}
                </span>
        }
    </button>
}

export default Button;